import { AxiosPrivado } from '../componentes/axios/Axios';
import {
  DashboardEmpleadoResumen,
  PedidosListarEmpleadoId,
  CotizacionesListarEmpleadoId,
} from '../configuracion/apiUrls';

// Datos prototipo de respaldo alineados al contrato oficial de Backend
const PRESETS_DASHBOARD = {
  // Alberto Amador (ID 9) - Vendedor Senior
  9: {
    empleado: {
      id: 9,
      nombreCompleto: 'Alberto Amador',
      cargo: 'Ejecutivo de Ventas Senior',
      fechaConsulta: new Date().toISOString().split('T')[0],
    },
    pedidosAsignados: {
      totalPendientes: 6,
      totalProgramadas: 4,
      totalEnRuta: 2,
      totalHoy: 3,
      items: [
        {
          id: 382,
          cliente: 'Distribuidora San José',
          fecha: new Date().toISOString().split('T')[0],
          hora: '10:30 AM',
          total: 4500.00,
          estado: 'Programada',
          direccion: 'Col. Kennedy, 2da entrada',
          contacto: '+504 9876-5432',
        },
        {
          id: 385,
          cliente: 'Comercial La Bendición',
          fecha: new Date().toISOString().split('T')[0],
          hora: '02:00 PM',
          total: 8250.00,
          estado: 'En Ruta',
          direccion: 'Bo. El Centro, Calle 5',
          contacto: '+504 3321-7788',
        },
        {
          id: 388,
          cliente: 'Ferretería & Abarrotes del Norte',
          fecha: new Date().toISOString().split('T')[0],
          hora: '04:15 PM',
          total: 12400.00,
          estado: 'Programada',
          direccion: 'Anillo Periférico, salida a Valle de Ángeles',
          contacto: '+504 9555-1234',
        },
        {
          id: 390,
          cliente: 'Super San Juan',
          fecha: new Date(Date.now() + 86400000).toISOString().split('T')[0],
          hora: '09:00 AM',
          total: 6100.00,
          estado: 'Pendiente',
          direccion: 'Col. Miraflores, Blvd. Centroamérica',
          contacto: '+504 8899-4455',
        },
        {
          id: 392,
          cliente: 'Inversiones Mercantiles S.A.',
          fecha: new Date(Date.now() + 86400000 * 2).toISOString().split('T')[0],
          hora: '11:00 AM',
          total: 15300.00,
          estado: 'Pendiente',
          direccion: 'Parque Industrial Amarateca',
          contacto: '+504 2235-9000',
        },
      ],
    },
    cotizaciones: {
      mesActualConteo: 16,
      mesActualMonto: 215400.00,
      pendientesAprobacion: 5,
      tasaCierre: 68.5,
      ultimasCotizaciones: [
        { id: 104, cliente: 'Constructora Lempira', monto: 45000.00, fecha: '2026-10-22', estado: 'Pendiente' },
        { id: 102, cliente: 'Agrocomercial del Sur', monto: 28600.00, fecha: '2026-10-21', estado: 'Aprobada' },
        { id: 99, cliente: 'Hospital Privado La Paz', monto: 62000.00, fecha: '2026-10-18', estado: 'Pendiente' },
      ],
    },
    ventas: {
      hoy: {
        conteo: 7,
        totalMonto: 38450.00,
        contado: 24200.00,
        credito: 14250.00,
      },
      mesActual: {
        conteo: 94,
        totalMonto: 457912.50,
        metaMes: 500000.00,
        porcentajeMeta: 91.5,
      },
    },
    carteraCreditos: {
      totalClientesAsignados: 22,
      saldoTotalPendiente: 112450.00,
      clientesEnMoraConteo: 3,
      saldoMora: 18750.00,
      clientesMora: [
        {
          creditoId: 45,
          clienteId: 108,
          nombre: 'Inversiones del Norte S. de R.L.',
          saldoVencido: 9200.00,
          diasAtraso: 24,
          telefono: '+504 9870-1122',
          limiteCredito: 25000.00,
        },
        {
          creditoId: 52,
          clienteId: 114,
          nombre: 'Comercial Santa Fe',
          saldoVencido: 5350.00,
          diasAtraso: 14,
          telefono: '+504 3344-5566',
          limiteCredito: 15000.00,
        },
        {
          creditoId: 58,
          clienteId: 122,
          nombre: 'Pulpería & Mercadito El Ahorro',
          saldoVencido: 4200.00,
          diasAtraso: 8,
          telefono: '+504 8877-6655',
          limiteCredito: 10000.00,
        },
      ],
    },
  },

  // Por defecto (Cualquier otro colaborador)
  default: {
    empleado: {
      id: 1,
      nombreCompleto: 'Colaborador SIGVEM',
      cargo: 'Vendedor / Asesor Comercial',
      fechaConsulta: new Date().toISOString().split('T')[0],
    },
    pedidosAsignados: {
      totalPendientes: 3,
      totalProgramadas: 2,
      totalEnRuta: 1,
      totalHoy: 2,
      items: [
        {
          id: 395,
          cliente: 'Abarrotería El Centro',
          fecha: new Date().toISOString().split('T')[0],
          hora: '11:00 AM',
          total: 3800.00,
          estado: 'Programada',
          direccion: 'Centro de Tegucigalpa',
          contacto: '+504 9900-1122',
        },
        {
          id: 398,
          cliente: 'Distribuidora Los Laureles',
          fecha: new Date().toISOString().split('T')[0],
          hora: '03:30 PM',
          total: 5400.00,
          estado: 'En Ruta',
          direccion: 'Col. Los Laureles',
          contacto: '+504 8811-2233',
        },
      ],
    },
    cotizaciones: {
      mesActualConteo: 8,
      mesActualMonto: 98500.00,
      pendientesAprobacion: 2,
      tasaCierre: 75.0,
      ultimasCotizaciones: [
        { id: 107, cliente: 'Empresa Modelo', monto: 18000.00, fecha: '2026-10-23', estado: 'Pendiente' },
        { id: 105, cliente: 'Comercial Suyapa', monto: 12500.00, fecha: '2026-10-20', estado: 'Aprobada' },
      ],
    },
    ventas: {
      hoy: {
        conteo: 4,
        totalMonto: 16800.00,
        contado: 12000.00,
        credito: 4800.00,
      },
      mesActual: {
        conteo: 46,
        totalMonto: 215300.00,
        metaMes: 250000.00,
        porcentajeMeta: 86.1,
      },
    },
    carteraCreditos: {
      totalClientesAsignados: 12,
      saldoTotalPendiente: 42100.00,
      clientesEnMoraConteo: 1,
      saldoMora: 4800.00,
      clientesMora: [
        {
          creditoId: 61,
          clienteId: 130,
          nombre: 'Minisúper La Esperanza',
          saldoVencido: 4800.00,
          diasAtraso: 12,
          telefono: '+504 9456-7890',
          limiteCredito: 10000.00,
        },
      ],
    },
  },
};

export const DashboardServicio = {
  /**
   * Obtiene el resumen del dashboard operativo para un empleado
   */
  async obtenerResumenEmpleado(empleadoId, fecha = null) {
    const fechaQuery = fecha || new Date().toISOString().split('T')[0];

    // 1. Intentar llamar al nuevo endpoint del backend (timeout corto para no demorar la carga si aún no está desplegado)
    try {
      const resp = await AxiosPrivado.get(
        `${DashboardEmpleadoResumen}?empleadoId=${empleadoId}&fecha=${fechaQuery}`,
        { timeout: 2500 }
      );
      if (resp && resp.data && resp.data.empleado) {
        return {
          datos: resp.data,
          origen: 'API_REAL',
        };
      }
    } catch (err) {
      // Endpoint consolidado aún no desplegado en producción
    }

    // 2. Intentar llamar a endpoints existentes de pedidos y cotizaciones para mezclar datos reales
    let pedidosReales = null;
    let cotizacionesReales = null;

    try {
      const [resPedidos, resCotizaciones] = await Promise.allSettled([
        AxiosPrivado.get(`${PedidosListarEmpleadoId}?empleadoId=${empleadoId}`, { timeout: 3000 }),
        AxiosPrivado.get(`${CotizacionesListarEmpleadoId}?empleadoId=${empleadoId}`, { timeout: 3000 }),
      ]);

      if (resPedidos.status === 'fulfilled' && Array.isArray(resPedidos.value.data)) {
        pedidosReales = resPedidos.value.data;
      }
      if (resCotizaciones.status === 'fulfilled' && Array.isArray(resCotizaciones.value.data)) {
        cotizacionesReales = resCotizaciones.value.data;
      }
    } catch (err) {
      // Fallback a preset prototipo
    }

    // 3. Fallback inteligente a datos prototipo según preset
    const preset = PRESETS_DASHBOARD[empleadoId] || PRESETS_DASHBOARD.default;
    const copia = JSON.parse(JSON.stringify(preset));
    copia.empleado.id = empleadoId;

    // Si obtuvimos pedidos reales de la API, enriquecemos el prototipo con datos reales
    if (pedidosReales && pedidosReales.length > 0) {
      const pendientes = pedidosReales.filter(
        (p) => p.estado === 'Pendiente' || p.estado === 'Programada' || p.estado === 'En Ruta'
      );
      copia.pedidosAsignados.totalPendientes = pendientes.length;
      copia.pedidosAsignados.totalProgramadas = pedidosReales.filter((p) => p.estado === 'Programada').length;
      copia.pedidosAsignados.totalEnRuta = pedidosReales.filter((p) => p.estado === 'En Ruta').length;
      if (pendientes.length > 0) {
        copia.pedidosAsignados.items = pendientes.slice(0, 6).map((p) => ({
          id: p.id,
          cliente: p.cliente?.nombreCompleto || p.clienteNombre || `Cliente #${p.clienteId}`,
          fecha: p.fecha ? p.fecha.split('T')[0] : fechaQuery,
          hora: p.hora || '09:00 AM',
          total: Number(p.total || 0),
          estado: p.estado,
          direccion: p.direccion || 'Dirección de entrega',
          contacto: p.cliente?.telefono || 'Sin teléfono',
        }));
      }
    }

    // Si obtuvimos cotizaciones reales
    if (cotizacionesReales && cotizacionesReales.length > 0) {
      copia.cotizaciones.mesActualConteo = cotizacionesReales.length;
      copia.cotizaciones.mesActualMonto = cotizacionesReales.reduce(
        (acc, c) => acc + (Number(c.total) || 0),
        0
      );
      copia.cotizaciones.pendientesAprobacion = cotizacionesReales.filter(
        (c) => c.estado === 'Emitida' || c.estado === 'Pendiente'
      ).length;
    }

    return {
      datos: copia,
      origen: 'PROTOTIPO_ACTIVO',
    };
  },
};
